(function () {
  'use strict';
  // Adult Terms
  const triggerAccept = document.querySelector('.js-accept-terms');
  const addToCartBtn = document.querySelector('.add-to-cart[type=submit]');

  if (typeof (triggerAccept) != 'undefined' && triggerAccept != null) {
    triggerAccept.addEventListener('change', event => {
      if (event.target.checked) {
        addToCartBtn.removeAttribute('disabled');
      } else {
        addToCartBtn.setAttribute('disabled', 'disabled');
      }
    });
  }
  // End Adult Terms

  // Trigger Gift Box
  const giftBox = new theme.Modals('GiftBoxPopup', 'giftbox-popup-modal', {
    closeOffContentClick: false,
    bodyOpenClass: ['modal-open', 'giftbox-modal-open']
  });

  function addGiftbox() {
    const addBtn = document.querySelector('.js-add-giftbox');
    const drawer = new theme.Drawers('CartDrawer', 'cart');

    addBtn.addEventListener('click', () => {
      let variantID = parseInt(addBtn.getAttribute('data-variant-id'));
      let formData = {
        'items': [{
          'id': variantID,
          'quantity': 1
        }]
      };

      fetch(theme.routes.cartAdd, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then(response => response.json())
        .then(function (data) {
          if (data.status === 422) {
            console.log("error adding to cart", data);
          } else {
            document.dispatchEvent(new CustomEvent('cart:build'));
            if (document.body.classList.contains('template-cart')) {
              giftBox.close();
            } else {
              drawer.open();
            }
          }
        });
    });
  }

  function cancelGiftbox() {
    const cancelBtn = document.querySelector('.js-cancel-giftbox');

    cancelBtn.addEventListener('click', () => {
      const expiryTimes = parseInt(document.querySelector('#GiftBoxPopup').getAttribute('data-delay-times')) * 1000;
      let expiry = new Date(new Date().getTime() + expiryTimes);

      Cookies.set('giftbox-popup', 'cancel', { path: '/', expires: expiry });
    });
  }

  function giftBoxModal() {
    giftBox.open();
    addGiftbox();
    cancelGiftbox();
  }

  function openGiftBox(cartItems) {
    const vendorCompare = ['Giften', 'Giften Market'];
    const giftBoxSKU = 'BYOGB20';
    const giftBoxCookie = Cookies.get('giftbox-popup');
    let totalQty = 0;
    let hasGiftBox = false;
    
    for (const key in cartItems) {
      if (Object.hasOwnProperty.call(cartItems, key)) {
        const cartItem = cartItems[key];
        let itemVendor = cartItem.vendor;
        let itemSKU = cartItem.sku;
        let itemQty = cartItem.quantity;

        if (!vendorCompare.includes(itemVendor) && itemSKU != giftBoxSKU) {
          totalQty += itemQty;
        }

        if (itemSKU == giftBoxSKU) {
          hasGiftBox = true;
        }
      }
    }

    if (totalQty >= 3 & !hasGiftBox & !giftBoxCookie) {
      giftBoxModal();
    } else {
      return;
    }
  }

  function giftBoxOnLoad() {
    $.getJSON(theme.routes.cart, function (cart) {
      openGiftBox(cart.items);
    });
  }

  if (window.location.pathname === '/cart') {
    giftBoxOnLoad();
  }

  document.addEventListener('ajaxProduct:added', function () {
    setTimeout(giftBoxOnLoad, 1400);
  });

  document.addEventListener('cart:build', function (evt) {
    setTimeout(giftBoxOnLoad, 1400);
  });
  document.addEventListener('cart:updated', function (evt) {
    openGiftBox(evt.detail.cart.items);
  });
})();



$(document).ready(function () {
    $('.git-popup').on('click', function (event) {
        event.preventDefault(); 
        $('.get-in-model, .get-in-overlay').addClass('open');
    });
    $('.get-in-model-close, .get-in-overlay').on('click', function () {
        $('.get-in-model, .get-in-overlay').removeClass('open');
    });
  
});

